import React, { useEffect, useState } from 'react';
import UIEventBus from '../EventBus';

const MouseTooltip: React.FC = () => {
    const [text, setText] = useState<string | null>(null);
    const [position, setPosition] = useState({ x: 0, y: 0 });

    useEffect(() => {
        const handleMouseMove = (e: MouseEvent) => {
            setPosition({ x: e.clientX, y: e.clientY });
        };

        const handleShow = (msg: string) => setText(msg);
        const handleHide = () => setText(null);

        window.addEventListener('mousemove', handleMouseMove);
        UIEventBus.on('showTooltip', handleShow);
        UIEventBus.on('hideTooltip', handleHide);

        return () => {
            window.removeEventListener('mousemove', handleMouseMove);
            UIEventBus.remove('showTooltip', handleShow);
            UIEventBus.remove('hideTooltip', handleHide);
        };
    }, []);

    if (!text) return null;

    return (
        <div
            style={{
                position: 'fixed',
                top: position.y + 15, // Offset to not overlap cursor
                left: position.x + 15,
                background: 'black',
                padding: '4px 16px',
                pointerEvents: 'none',
                zIndex: 1000,
                textAlign: 'center',
                boxSizing: 'border-box',
            }}
        >
            <p style={{ margin: 0, color: 'white', fontFamily: 'monospace', fontSize: '16px' }}>
                {text}
            </p>
        </div>
    );
};

export default MouseTooltip;
